import template from './leadCard.html';
import controller from './leadCardCtrl';

export default {
  template,
  controller,
  bindings: {
    isSmallDevice: '<',
    card: '<',
    isSingle: '<',
    isShowTimeline: '<',
    timelineStatusList: '<',
    onChangeCardStatus: '&',
    isCorporateUser: '<',
    labelsSettings: '<',
    onLabelToggle: '&',
    onRefreshLabelsSettings: '&',
    isShrink: '<',
    isCompact: '<',
    onMenuClick: '&',
    onViewBorrower: '&',
    onViewLoanApp: '&',
    onDuplicateLoan: '&',
    onViewSubmission: '&',
    onViewLoanInformation: '&',
    onCardClick: '&',
    onToggleIsShrink: '&',
    onDeletePipelineItem: '&',
    probabilityList: '<',
    onChangeProbability: '&',
    onChangeSubStatus: '&',
    onLeadAddNote: '&',
    conversionOptions: '<',
    onConvertCard: '&',
    isMergeLeadAndOpportunities: '<',
    isPipeline: '<',
  },
};
